// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 134) return "app-launcher/actiondesk.5040528ba693599281a9.min.js";
	if (chunkId === 635) return "app-launcher/635.47caacf2c744f463cef7.min.js";
	if (chunkId === 9) return "app-launcher/static.861fac91755f08a425ec.min.js";
	if (chunkId === 260) return "app-launcher/260.514537fac2eb2a4fe66e.min.js";
	if (chunkId === 807) return "app-launcher/dynamic-locale-jp-json.72b0c0a2f0aa904fa19f.min.js";
	if (chunkId === 138) return "app-launcher/md-editor.bbf5b5de9eadf536ec83.min.js";
	if (chunkId === 176) return "app-launcher/charts.745ef8e15ac90106476d.min.js";
	if (chunkId === 522) return "app-launcher/maps.d8171f7d4b777491ff7c.min.js";
	if (chunkId === 84) return "app-launcher/dendrogram.35ad95f1df0dc1ea63b4.min.js";
	if (chunkId === 77) return "app-launcher/graph.44307855224844e8e17c.min.js";
	if (chunkId === 108) return "app-launcher/sankey.9c2094337ae1d23baace.min.js";
	if (chunkId === 344) return "app-launcher/344.9543ca88764c02f4b4d0.min.js";
	if (chunkId === 304) return "app-launcher/304.d729656c410d8dccbb63.min.js";
	if (chunkId === 373) return "app-launcher/373.29292ad7b8980042d58e.min.js";
	if (chunkId === 535) return "app-launcher/535.6d5d66d12a0ba9553fa0.min.js";
	if (chunkId === 113) return "app-launcher/113.a6f18126d2bcfcab7d22.min.js";
	if (chunkId === 786) return "app-launcher/786.01350f0efa5dcbfe407e.min.js";
	// return url for filenames based on template
	return undefined;
};